<template>
    <div class="header-box">
        <Content class="header-content">
            <router-link to="/">
                <div class="logo">
                    <img src="../../assets/image/logo.png?v=2020" width="150" height="40" />
                </div>
            </router-link>
            <ul class="menu">
                <li :class="{active:activeMenu==='/'}">
                    <router-link to="/">首页</router-link>
                </li>
                <li :class="{active:activeMenu==='/list'}">
                    <router-link to="/list">大数据词云</router-link>
                </li>
                <li><a href="https://so.5118.com/" target="_blank">素材搜索</a></li>
                <li><a href="https://www.5ce.com/hot" target="_blank">热榜</a></li>
                <li><a href="https://wyc.5118.com/" target="_blank">伪原创</a></li>
                <!-- <li><a href="https://zlb.5118.com/" target="_blank">知乎占楼</a></li> -->
                <li><a href="http://www.ciliuti.com/" target="_blank">文章采集</a></li>
                <li><a href="https://ai.5118.com/" target="_blank">文章采编器</a></li>
                <!-- <li><a href="https://ai.5ce.com" target="_blank">新媒体智能编辑器</a></li> -->
                <li><a href="https://www.5118.com/naotu" target="_blank">需求图谱</a></li>
                <li><a href="https://ci.5118.com/" target="_blank">流量挖掘</a></li>
                <li><a href="https://www.5118.com/" target="_blank">站长工具</a></li>
            </ul>
            <tool />
            <!-- <div class="search">
        <Search v-if="activeMenu==='/edit'"></Search>
      </div> -->
            <div class="head-image-box" v-if="info">
                <el-dropdown>
                    <el-avatar :size="30" :src="info.avatar"></el-avatar>
                    <i class="icon-head-down"></i>
                    <el-dropdown-menu slot="dropdown">
                        <a :href="settingUrl" target="_blank" style="color:#606266">
                            <el-dropdown-item icon="el-icon-setting">设置</el-dropdown-item>
                        </a>
                        <el-dropdown-item icon="el-icon-switch-button" @click.native="logout">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="head-image-box2" v-else>
                <a :href="loginLink" style="color:#fff;float:right">登录/注册</a>
            </div>
        </Content>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapMutations, mapState } from "vuex";
import tool  from "./Intelligence_tool"
// import Search from "./Search";

export default {
    componentName: "header",
    data() {
        return {
            loginLink:
                process.env.NODE_ENV === "development"
                    ? "http://d-account.5118.com/account/login?status=wordcloud"
                    : "https://account.5118.com/signin?status=wordcloud",
            settingUrl: "https://account.5118.com/signin/update?p=kt1",
        };
    },
    components: {
        // Search
        tool
    },
    computed: {
        ...mapState("menu", ["activeMenu"]),
        ...mapState("user", ["info"]),
    },
    methods: {
        ...mapMutations("user", ["MSet"]),
        logout() {
            Cookies.remove("user");
            this.MSet(null);
        },
    },
};
</script>

<style type="text/less" lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";

.header-box {
    background-color: @theme-color;
    height: @herder-height;
    display: flex;
    align-items: center;

    .header-content {
        display: flex;
        position: relative;

        .logo {
            img {
                vertical-align: middle;
                margin-right: 20px;
            }
        }

        .menu {
            display: flex;
            align-items: center;

            li {
                margin-left: 10px;
                padding: 5px 0;
                border-bottom: 3px solid transparent;

                a {
                    color: white;
                }

                &.active {
                    border-bottom: 3px solid @info-color;
                }
            }
        }

        .search {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .head-image-box {
            display: flex;
            align-items: right;
            float: right;
            position: absolute;
            right: 0;
            top: 7px;
        }

        .head-image-box2 {
            position: absolute;
            right: 0;
            top: 7px;
        }
    }
}
.icon-head-down {
    content: "";
    z-index: 2;
    border: 4px solid transparent;
    border-top: 4px solid white;
    position: absolute;
    top: 50%;
    right: -12px;
}
.el-dropdown-menu__item:hover {
    background-color: rgb(38, 38, 150);
    color: white;
}
</style>
